export default "__VITE_PUBLIC_ASSET__903ef789__"